<template>
  <div class="px-4 ml-6 pt-4 layout-row layout-wrap">

    <!-- Kopfdaten -->

    <div class="flex-gt-sm-100 flex-100 mt-2">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.REPORTER_PERSONAL_CONTRIBUTION') }}</span>
      </div>

      <melder path="headerData"
              v-model="model.headerData"
              :reportReason="model.reportType"
              :formKey="model.formType"
              :additionalItemsList="additionalItemsList"
              :validationRef="validationRef"
              :isImport="true"
              :disableManuallyValidate="true"
      ></melder>
    </div>

    <div class="flex-gt-sm-100 flex-100 mt-5 layout-row layout-wrap">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.BASE_PROGRESS_HEADER') }}</span>
      </div>

      <!-- Gesamtbeurteilung Tumorstatus -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             class="layout-row"
                             :name="path + '.additionalFields.progress.gesamtbeurteilung_tumorstatus'"
                             :ref="path + '.additionalFields.progress.gesamtbeurteilung_tumorstatus'"
                             :rules="{required: true, tumor_state_overall: [model.additionalFields.progress.verlauf_lokaler_tumorstatus, model.additionalFields.progress.verlauf_tumorstatus_lymphknoten, model.additionalFields.progress.verlauf_tumorstatus_fernmetastasen, icd.icd10.code]}"
                             v-slot="{ errors }">
          <v-select
            :color="compColor.primeColor"
            :label="$t('FORMS_DIVERSE.BASE_PROGRESS_OVERALL_ASSESSMENT_TUMOR') + ' *'"
            v-model="model.additionalFields.progress.gesamtbeurteilung_tumorstatus"
            :items="tumorStatusGeneralTypes"
            outlined
            :disabled="reportType !== 'statusaenderung'"
            @change="setDefaultValuesOfStates(model.additionalFields.progress.gesamtbeurteilung_tumorstatus)"
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error-messages="errors[0]"
            :menu-props="{ bottom: true, offsetY: true }"
            :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>

          <v-tooltip bottom open-delay="1000" max-width="800">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="layout-row layout-align-start-start ml-2" :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                   style="cursor: pointer;">
                <v-icon :color="compColor.prime" medium>info</v-icon>
              </div>
            </template>

            <p style="text-align: justify;" class="my-1">{{ $t('FORMS_DIVERSE.INFO_BASE_PROGRESS_OVERALL_ASSESSMENT_TUMOR') }}</p>
          </v-tooltip>
        </validation-provider>
      </div>

      <div class="flex-gt-sm-50 flex-100 px-2"></div>

      <!-- Tumorstatus Primärtumor -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.additionalFields.progress.verlauf_lokaler_tumorstatus'"
                             :ref="path + '.additionalFields.progress.verlauf_lokaler_tumorstatus'"
                             rules=""
                             v-slot="{ errors }">
          <v-select
            :color="compColor.primeColor"
            :label="$t('FORMS_DIVERSE.BASE_PROGRESS_PROGRESS_LOCALE_TUMOR')"
            v-model="model.additionalFields.progress.verlauf_lokaler_tumorstatus"
            :items="tumorStatusLokalTypes"
            @change="triggerValidationOfGeneralState('verlauf_lokaler_tumorstatus')"
            outlined
            clearable
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error-messages="errors[0]"
            :menu-props="{ bottom: true, offsetY: true }"
            :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </validation-provider>
      </div>

      <!-- Tumorstatus Lymphknoten -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.additionalFields.progress.verlauf_tumorstatus_lymphknoten'"
                             :ref="path + '.additionalFields.progress.verlauf_tumorstatus_lymphknoten'"
                             rules=""
                             v-slot="{ errors }">
          <v-select
            :color="compColor.primeColor"
            :label="$t('FORMS_DIVERSE.BASE_PROGRESS_STATE_LYMPH_NODES')"
            v-model="model.additionalFields.progress.verlauf_tumorstatus_lymphknoten"
            :items="tumorStatusLymphNodesTypes"
            @change="triggerValidationOfGeneralState('verlauf_tumorstatus_lymphknoten')"
            outlined
            clearable
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error-messages="errors[0]"
            :menu-props="{ bottom: true, offsetY: true }"
            :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </validation-provider>
      </div>

      <!-- Tumorstatus Fernmetastasen -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.additionalFields.progress.verlauf_tumorstatus_fernmetastasen'"
                             :ref="path + '.additionalFields.progress.verlauf_tumorstatus_fernmetastasen'"
                             :rules="{required: model.reportDisplayName === 'statusaenderung_metastase'}"
                             v-slot="{ errors }">
          <v-select
            :color="compColor.primeColor"
            :label="formatLabelOfTumorStateDistanceMetastase('FORMS_DIVERSE.BASE_PROGRESS_DISTANT_METASTASIS')"
            v-model="model.additionalFields.progress.verlauf_tumorstatus_fernmetastasen"
            :items="tumorStatusMetastasesTypes"
            @change="triggerValidationOfGeneralState('verlauf_tumorstatus_fernmetastasen')"
            outlined
            clearable
            :disabled="model.reportDisplayName === 'statusaenderung_metastase'"
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error-messages="errors[0]"
            :menu-props="{ bottom: true, offsetY: true }"
            :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </validation-provider>
      </div>

      <div class="layout-wrap flex-gt-sm-100 flex-100 mb-4 mx-2"
           v-if="model.additionalFields.progress.gesamtbeurteilung_tumorstatus === 'P' && model.additionalFields.progress.verlauf_tumorstatus_fernmetastasen === 'R'">
        <lx-alert-box color="orange">
          <span>{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_ONE') }}</span>
          <span class="font-weight-bold">{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_TWO') }}</span>
          <span>{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_THREE') }}</span>
        </lx-alert-box>
      </div>
    </div>

    <div class="flex-gt-sm-100 flex-100 mt-5">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.GENERAL_PERFORMANCE_STATE') }}</span>
      </div>

      <leistungszustand path="additionalFields.progress.allgemeiner_leistungszustand"
                        v-model="model.additionalFields.progress.allgemeiner_leistungszustand"
      ></leistungszustand>
    </div>

    <!--  Modul Prostata bei C61  -->

    <div class="flex-gt-sm-100 flex-100 layout-row layout-wrap mt-5" v-if="icd && icd.icd10 && icd.icd10.code === 'C61'">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">Modul Prostata bei Diagnose mit ICD-10 C61</span>
      </div>

      <!-- datum_psa -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.additionalFields.progress.prostata.datum_psa'"
                             :ref="path + '.additionalFields.progress.prostata.datum_psa'"
                             :rules="{german_date:true,date_not_in_future:true,date_must_be_lesser_than_death:[dateOfDeath,model.additionalFields.progress.prostata.datum_psa_genauigkeit]}"
                             v-slot="{ errors }">
          <lx-datepicker
            :color="compColor.textInput"
            :name="path + '.additionalFields.progress.prostata.datum_psa'"
            :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_DATE') + ' (wenn abweichend von Untersuchungsdatum)'"
            class="mr-1"
            @input="setDateAccuracyAfterDate"
            :dense="denseFields"
            :error="errors[0]"
            v-model="model.additionalFields.progress.prostata.datum_psa"
          ></lx-datepicker>
        </validation-provider>
      </div>

      <!-- datum_psa_genauigkeit -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <div class="layout-row">
          <validation-provider tag="div"
                               class="flex"
                               :name="path + '.additionalFields.progress.prostata.datum_psa_genauigkeit'"
                               :ref="path + '.additionalFields.progress.prostata.datum_psa_genauigkeit'"
                               rules=""
                               v-slot="{ errors }">
            <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_DATE_ACCURACY')"
                v-model="model.additionalFields.progress.prostata.datum_psa_genauigkeit"
                :items="DateAccuracyTypes"
                outlined
                @change="validateDateAfterChangeOfAccuracy()"
                :hide-details="!errors || errors.length <= 0"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>

          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                   :class="{'mt-1': !denseFields}"
                   style="cursor: pointer;">
                <v-icon :color="compColor.prime" medium>info</v-icon>
              </div>
            </template>
            <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
          </v-tooltip>
        </div>
      </div>

      <!--psa -->

      <div class="flex-gt-sm-33 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.additionalFields.progress.prostata.psa'"
                             :ref="path + '.additionalFields.progress.prostata.psa'"
                             :rules="{decimal:3, between: [0,99999]}"
                             v-slot="{ errors }">
          <lx-numberfield :dense="denseFields"
                          @input="setDateOfPSAPerDefault(model.additionalFields.progress.prostata.psa)"
                          v-model="model.additionalFields.progress.prostata.psa"
                          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_VALUE')"
                          suffix="ng/ml"
                          separator=","
                          :error-messages="errors[0]"
          ></lx-numberfield>
        </validation-provider>
      </div>
    </div>

    <!--  Fernmetastase  -->

    <div class="flex-gt-sm-100 flex-100 mt-2 mb-4" v-if="model.reportDisplayName === 'statusaenderung_metastase' || model.additionalFields.progress.verlauf_tumorstatus_fernmetastasen === 'R'">
      <div class="flex-100 px-3 py-1 mb-3 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">Fernmetastasen</span>
      </div>

      <fernmetastase path="additionalFields.progress.fernmetastase"
                     v-model="model.additionalFields.progress.fernmetastase"
                     :leadDate="model.date"
                     :dateOfDeath="dateOfDeath"
                     :isRequired="true"
                     :validationRef="validationRef"
                     :isAdditionalImportForm="isAdditionalImportForm"
                     :disableManuallyValidate="true"
                     v-bind="{addItem, deleteItem}"
      ></fernmetastase>
    </div>

    <!--  TNM  -->

    <div class="flex-gt-sm-100 flex-100 mt-3" v-if="model.reportDisplayName === 'statusaenderung' || model.reportDisplayName === 'statusaenderung_metastase' || model.reportDisplayName === 'vollremission_new' || model.reportDisplayName === 'vollremission_cont'">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">TNM</span>
      </div>

      <tnm path="additionalFields.progress.tnm"
           v-model="model.additionalFields.progress.tnm"
           :formKey="model.formType"
           :diagCode="icd && icd.icd10 && icd.icd10.code"
           :dateOfDeath="dateOfDeath"
           :diagDate="diagDate"
           :base="model.additionalFields.progress"
           :disableManuallyValidate="true"
      ></tnm>
    </div>

    <!--  ANMERKUNG  -->

    <div class="flex-gt-sm-100 flex-100 mt-3">
      <div class="flex-100 px-3 py-1 mb-6 mx-2"
           :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.ANNOTATION_HEADER') }}</span>
      </div>

      <anmerkung path="additionalFields.progress.anmerkung"
                 :isDisabled="isFormDisabled()"
                 v-model="model.additionalFields.progress.anmerkung"
                 class="layout-wrap flex-gt-sm-100 flex-100"></anmerkung>
    </div>
  </div>
</template>

<script>
import metaData from '../../../components/documentation/shared/formsMetaData'
import utils from '../../../common/utils'

import Fernmetastase from '../../../components/documentation/shared/Fernmetastase'
import Tnm from '../../../components/documentation/shared/TNM'
import Leistungszustand from '../../../components/documentation/shared/Leistungszustand'
import Melder from '../../../components/documentation/shared/Melder'
import Anmerkung from '../../../components/documentation/shared/Anmerkung.vue'

export default {
  name: "Progress",
  mixins: [metaData, utils],
  components: {
    Fernmetastase,
    Leistungszustand,
    Tnm,
    Melder,
    Anmerkung
  },
  props: {
    value: {
      type: Object,
      default: () => ({ additionalFields: { progress: {} } })
    },
    path: {
      type: String
    },
    icd: {
      type: Object,
      default: () => ({
        icd10: {}
      })
    },
    reportType: {
      type: String
    },
    isAdditionalImportForm: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    additionalItemsList: {
      type: Array,
      default: () => ([])
    },
    dateOfDeath: {
      type: String
    },
    diagDate: {
      type: [Object, String]
    }
  },
  data () {
    return {
      model: {
        additionalFields: { progress: {} }
      },
      tumorStatusGeneralTypesUN: [
        { value: 'V_cont', text: 'W - Weiterhin bestehende Vollremission (complete remission, CR)', short: 'Vollremission' },
        { value: 'K', text: 'K - Keine Änderung (no change, NC) = stable disease', short: 'Keine Änderung' }
      ],
      tumorStatusLokalTypes: [],
      tumorStatusLymphNodesTypes: [],
      tumorStatusMetastasesTypes: [],
      DateAccuracyTypes: null
    }
  },
  created () {
    this.tumorStatusLokalTypes = this.formsMetaData.TumorStatusLokalTypes
    this.tumorStatusLymphNodesTypes = this.formsMetaData.TumorStatusLymphNodesTypes
    this.tumorStatusMetastasesTypes = this.formsMetaData.TumorStatusMetastasesTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * Set date accuracy per default after date input
     */
    setDateAccuracyAfterDate () {
      // set datum_psa_genauigkeit if not exists after changing datum_psa in datepicker
      if (this.model.additionalFields?.progress?.prostata?.datum_psa && !this.model.additionalFields?.progress?.prostata?.datum_psa_genauigkeit) {
        this.$set(this.model.additionalFields.progress.prostata, 'datum_psa_genauigkeit', 'E')
      }
    },

    /**
     * Validate date after changing date accuracy
     */
    validateDateAfterChangeOfAccuracy () {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.additionalFields.progress.prostata.datum_psa']) {
          this.$refs[this.path + '.additionalFields.progress.prostata.datum_psa'].validate()
        }
      })
    },

    /**
     * Return label of tumor state metastasis in dependency to report reason
     *
     * @param text The text to localized
     * @returns {VueI18n.TranslateResult}
     */
    formatLabelOfTumorStateDistanceMetastase (text) {
      let label = this.$t(text)

      if (this.model.reportDisplayName==='statusaenderung_metastase') label += ' *'

      return label
    },

    /**
     * Trigger the validation of general state manually to prevent error message when valid after first input of one tumor state
     * and set default values of tnm after changing sub-state
     *
     */
    triggerValidationOfGeneralState (changedValue) {
      // set tnm-values per default when form is progress with distance metastasis
      if (changedValue === 'verlauf_tumorstatus_fernmetastasen' && this.model?.additionalFields?.progress?.verlauf_tumorstatus_fernmetastasen === 'R') {
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_t', undefined)
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_t', undefined)
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_n', undefined)
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_n', undefined)
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_m', 'c')
        this.$set(this.model.additionalFields.progress.tnm, 'tnm_m', '1')

        // set tnm-date, if leadDate from import exists
        if (this.model?.date) {
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_datum', this.model.date)
        }
      } else if (this.model?.additionalFields?.progress?.verlauf_tumorstatus_fernmetastasen !== 'R') {
        // delete array of fernmetastase, if other state than fernmetastase
        this.$delete(this.model.additionalFields.progress, 'fernmetastase')
      }

      this.$nextTick(() => {
        if (this.$refs && this.$refs[this.path + '.additionalFields.progress.gesamtbeurteilung_tumorstatus']) {
          // validation of general state must be triggered manually, because error message will be displayed after first changing
          // of one tumor state and general state is valid
          this.$refs[this.path + '.additionalFields.progress.gesamtbeurteilung_tumorstatus'].validate()
        }
      })
    },

    /**
     *  Set default values to substates after changing general state
     *
     * @param generalState
     */
    setDefaultValuesOfStates (generalState) {
      // diagnosis with C61, C8* or C9* needs no sub-status, when progression or partial-remission, then set substatus to "U"
      const diagnosisCode = this.icd?.icd10?.code || null
      const matchDiagnosisRegex = RegExp(/^C61|C8|C9/)
      const isDiagnosisWithoutSuBStatus =  matchDiagnosisRegex.test(diagnosisCode)

      // complete remission, CR
      if (generalState === 'V_new' || generalState === 'V_cont') {
        this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', 'K')
        this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', 'K')
        this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', 'K')
      }

      // no change, NC
      if (generalState === 'K' || generalState === 'U' || generalState === 'X') {
        this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', 'U')
        this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', 'U')
        this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', 'U')
      }

      // progression
      // do not change if report type is metastasis, the status fields must not be overwritten
      if (generalState === 'P' && this.reportType !== 'statusaenderung_metastase') {
        if (isDiagnosisWithoutSuBStatus) {
          this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', 'U')
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', 'U')
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', 'U')
        } else {
          this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', null)
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', null)
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', null)
        }
      }

      // partial remission, PR
      if (generalState === 'T') {
        if (isDiagnosisWithoutSuBStatus) {
          this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', 'U')
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', 'U')
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', 'U')
        } else {
          this.$set(this.model.additionalFields.progress, 'verlauf_lokaler_tumorstatus', null)
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_lymphknoten', null)
          this.$set(this.model.additionalFields.progress, 'verlauf_tumorstatus_fernmetastasen', null)
        }
      }
    },

    /**
     * Set date of PSA per default
     *
     * @param value The psa value
     */
    setDateOfPSAPerDefault (value) {
      let date = this.model && this.model.date ? this.model.date : null

      // set date of psa only when psa-value and date of form exist and date of psa is empty
      if (value && !this.model.additionalFields.progress.prostata.datum_psa) {
        this.$set(this.model.additionalFields.progress.prostata, 'datum_psa', date)
      }

      // clear empty psa-value, empty string will be converted to null-value
      this.refactorEmptyIntValue(value, null, 'psa')
    }
  },
  computed: {
    tumorStatusGeneralTypes () {
      return this.reportType === 'statusmeldungUN' || this.reportType === 'vollremission_cont' ? this.tumorStatusGeneralTypesUN : this.formsMetaData.TumorStatusGeneralTypesImport
    },

    // watch over changes of all tumor states
    tumorStates () {
      return [
        this.model.additionalFields.progress.verlauf_lokaler_tumorstatus,
        this.model.additionalFields.progress.verlauf_tumorstatus_lymphknoten,
        this.model.additionalFields.progress.verlauf_tumorstatus_fernmetastasen
      ]
    },
    tnmIsRequired () {
      return this.model.additionalFields.progress && (this.model.additionalFields.progress.verlauf_lokaler_tumorstatus === 'R' || this.model.additionalFields.progress.verlauf_tumorstatus_lymphknoten === 'R')
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue

          if (!this.model.additionalFields) {
            this.$set(this.model, 'additionalFields', { progress: {} })
          }
        }
      },
      immediate: true
    },
    'icd.icd10.code': {
      handler () {
        this.model.additionalFields.progress.prostata = {}
        this.setDefaultValuesOfStates(this.model.additionalFields.progress.gesamtbeurteilung_tumorstatus)

        // trigger validation to prevent error messages, when values of tumor states are valid
        this.$nextTick(() => {
          this.triggerValidationOfGeneralState()
        })
      }
    },
    reportType: {
      handler (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          // trigger validation to set error message, when values of tumor states are invalid
          this.$nextTick(() => {
            this.triggerValidationOfGeneralState()
          })
        }
      },
      immediate: true
    },

    // trigger parent validator after changing of one tumor state
    // without parent-validator-validate error message will not be shown
    tumorStates: {
      handler (newValue, oldValue) {
        // set metastases-array with one element as default, if verlauf_tumorstatus_fernmetastasen is set to R
        if (newValue[2] === 'R' && newValue[2] !== oldValue[2]) {
          this.$set(this.model.additionalFields.progress, 'fernmetastase', [{}])
          this.$set(this.model.additionalFields.progress.fernmetastase[0], 'fm_diagnosedatum', this.model.date)
          this.$set(this.model.additionalFields.progress.fernmetastase[0], 'fm_diagnosedatum_genauigkeit', 'E')
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_m', 'c')
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_m', '1')
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_t', undefined)
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_t', undefined)
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_c_p_u_praefix_n', undefined)
          this.$set(this.model.additionalFields.progress.tnm, 'tnm_n', undefined)

          if (this.model.date) {
            this.$set(this.model.additionalFields.progress.tnm, 'tnm_datum', this.model.date)
          }
        } else if (newValue[2] !== 'R' && newValue[2] !== oldValue[2] && this.model.reportDisplayName !== 'statusaenderung_metastase') {
          // unset mestatases if verlauf_tumorstatus_fernmetastasen is not R and report reason is not statusaenderung_metastase
          this.$set(this.model.additionalFields.progress, 'fernmetastase', undefined)
        }

        this.$nextTick(() => {
          this.validationRef.validate()
        })
      }
    }
  }
}
</script>
